var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.searchItems && _vm.searchItems.length
        ? _c(
            "p",
            { staticClass: "screening-content" },
            [
              _c("span", [_vm._v(_vm._s(_vm.$t("Sop.ScreeningContent")))]),
              _vm._l(_vm.searchItemsCopy, function(item, index) {
                return [
                  item.key === "lob"
                    ? [
                        _c(
                          "el-tag",
                          {
                            key: item.key + "-" + index,
                            attrs: { closable: "" },
                            on: {
                              close: function() {
                                return _vm.handleTagClose(item.key)
                              }
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t(item.label) + ": " + item.name) +
                                " "
                            )
                          ]
                        )
                      ]
                    : item.key === "trackDetailIds"
                    ? _c(
                        "el-tag",
                        {
                          key: item.key + "-" + index,
                          attrs: { closable: "" },
                          on: {
                            close: function() {
                              return _vm.handleTagClose(item.key)
                            }
                          }
                        },
                        [
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "dark",
                                content: _vm.$t(item.label) + ": " + item.name,
                                placement: "bottom"
                              }
                            },
                            [
                              _c("span", { staticClass: "track-short-show" }, [
                                _vm._v(
                                  _vm._s(_vm.$t(item.label) + ": " + item.name)
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    : item.key === "warnLevel"
                    ? _c(
                        "el-tag",
                        {
                          key: item.key + "-" + index,
                          attrs: { closable: "" },
                          on: {
                            close: function() {
                              return _vm.handleTagClose(item.key)
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(item.label) +
                                ": " +
                                _vm.getWarningText(item.value)
                            )
                          )
                        ]
                      )
                    : Array.isArray(item.value)
                    ? _c(
                        "el-tag",
                        {
                          key: item.key + "-" + index,
                          attrs: { closable: "" },
                          on: {
                            close: function() {
                              return _vm.handleTagClose(item.key)
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(item.label) + ": " + item.value.join("~")
                            )
                          )
                        ]
                      )
                    : _c(
                        "el-tag",
                        {
                          key: item.key + "-" + index,
                          attrs: { closable: "" },
                          on: {
                            close: function() {
                              return _vm.handleTagClose(item.key)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t(item.label) + ": " + item.value))]
                      )
                ]
              })
            ],
            2
          )
        : _vm._e(),
      _c("cargo-ag-grid", {
        attrs: {
          "config-module": _vm.configModule,
          "grid-options": _vm.gridOptions,
          "column-defs": _vm.columnDefs,
          "row-data": _vm.rowData
        }
      }),
      _c(
        "div",
        { staticClass: "pre-warning-footer" },
        [
          _c(
            "div",
            { staticClass: "left" },
            [
              _vm.type === "pre"
                ? _c(
                    "el-button",
                    {
                      key: "pre",
                      attrs: {
                        type: _vm.hasSelected ? "primary" : "info",
                        plain: "",
                        disabled: !_vm.hasSelected
                      },
                      on: {
                        click: function() {
                          return _vm.handleOperate(1)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Sop.ignoreSelected")))]
                  )
                : _c(
                    "el-button",
                    {
                      key: "ignore",
                      attrs: {
                        type: _vm.hasSelected ? "primary" : "info",
                        plain: "",
                        disabled: !_vm.hasSelected
                      },
                      on: {
                        click: function() {
                          return _vm.handleOperate(0)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Sop.restoreSelected")))]
                  )
            ],
            1
          ),
          _c("cargo-pagination", {
            attrs: {
              total: _vm.pagination.total,
              page: _vm.pagination.pageNum,
              limit: _vm.pagination.pageSize,
              layout: "total, prev, pager, next"
            },
            on: {
              "update:page": function($event) {
                return _vm.$set(_vm.pagination, "pageNum", $event)
              },
              "update:limit": function($event) {
                return _vm.$set(_vm.pagination, "pageSize", $event)
              },
              pagination: _vm.fetchData
            }
          })
        ],
        1
      ),
      _c("filter-dialog", {
        ref: "filterDialog",
        attrs: { visible: _vm.showFilter },
        on: { close: _vm.handleCloseFilter, search: _vm.handleSearch }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }